@if (isInvalid()) {
  <div>
    @if (hasRequiredError() || hasErrorEmptyInput()) {
      <small class="text-danger">
        {{message}}
      </small>
    }
    @if (hasErrorPattern()) {
      <small class="text-danger">
        {{messagePattern}}
      </small>
    }
    @if (!hasRequiredError() && hasErrorEmail()) {
      <small class="text-danger">
        {{messageEmail}}
      </small>
    }
    @if (hasErrorWebsitePattern()) {
      <small class="text-danger" >
        {{messageWebsiteUrl}}
      </small>
    }
    @if (hasErrorPhoneNumber()) {
      <small class="text-danger" >
        {{messagePhoneNumber}}
      </small>
    }
    @if (hasErrorZipcode()) {
      <small class="text-danger" >
        {{messageZipcode}}
      </small>
    }
    @if (hasErrorMin()) {
      <small class="text-danger" >
        {{minValueMessage}}
      </small>
    }
    @if (hasErrorMax()) {
      <small class="text-danger" >
        {{maxValueMessage}}
      </small>
    }
    @if (hasInvalidCommaSeparatedNumbersMax()) {
      <small class="text-danger" >
        {{invalidCommaSeparatedNumbersMessage}}
      </small>
    }
    @if (hasCustomValidatorError()) {
      <small class="text-danger" >
        {{customValidatorMessage}}
      </small>
    }
  </div>
}
